<template lang="">
    <v-card>
        
        <s-crud
            :config="config"
            title="Inductores de la Lista de Materiales"
            :filter="filter"
            add
            @add="send()"
            addNoFunction
            @rowSelected="rowSelected($event)"
            
            ref="InductorsList"
        >
            <template v-slot:filter>
                <v-container>
                    <v-row>                        
                        <v-col>
                            <s-text
                                label="Número de artículo"
                                v-model="filter.ItemCode"
                            ></s-text>
                        </v-col>
                        <v-col>
                            <s-text
                                label="Descripción"
                                v-model="filter.ItemName"
                            ></s-text>
                        </v-col>
                        <v-col>
                            <s-text
                                label="Grupo de artículos"
                                v-model="filter.ItmsGrpNam"
                            ></s-text>
                        </v-col>
                        <v-col>
							<!--no-default clearable-->
							<s-select-definition label="Método de Valorización"  clearable 
								v-model="filter.EvalSystem" :def="1734" />
						</v-col>
                    </v-row>
                </v-container>
            </template>            
        </s-crud>
        <v-dialog persistent v-model="openModal" v-if="openModal" width="1100">
			<v-card>
				<v-col>
					<v-row>
						<s-toolbar
							save
							@save="save({})"
							:color="'#BAB6B5'"
							dark
							label=""
							close
							@close="close()"
                            label="Datos de Inventario"
						/>
					</v-row>

					<v-row style="margin-left: 5px" justify="center">
                        <v-col cols="12" md="3" lg="3">
							<s-text
								label="Inductor"
								v-model="item.ItemCode"	
                                readonly															
							></s-text>
						</v-col>
						<v-col cols="12" md="3" lg="2">
							<s-text label="Método de Valorización" 
								v-model="item.EvalSystemName" readonly ></s-text>
						</v-col>
						<v-col cols="12" md="3" lg="2">
							<s-text
								label="Costo del Articulo"
								v-model="item.AvgPrice"								
								decimal 
                                readonly
							></s-text>
						</v-col>
                        <v-col cols="12" md="3" lg="2">
							<s-text
								label="Cantidad"
								v-model="item.Quantity"								
								decimal 
                               
							></s-text>
						</v-col>
                        <v-col cols="12" md="3" lg="2">
                            <v-btn fab x-small color="success" @click="addQuantity()">
								<i class="fas fa-plus"></i>
							</v-btn>
                        </v-col>
                       <v-col cols="12">                           
                            <v-data-table
                                    item-key="Father"
                                    dense
                                    fixed-header=""
                                    v-model="selectedSearch"
                                    :items="listMaterial"
                                    :headers="headersListMaterial"
                                    :items-per-page="5"
                                    :search="search"
                                    show-select
                                >
                            <template v-slot:top>
								<v-text-field v-model="search" label="Search" class="mx-4"></v-text-field>
							</template>
                            </v-data-table>
                       </v-col>
					</v-row>
                    
                   
				</v-col>
			</v-card>
		</v-dialog>
    </v-card>
</template>

<script>

    import ServiceInductors from '@/services/FreshProduction/ConfigFresh/InductorsService'

    export default {
        components: {
        
        },
        data() {
            return {
                filter:{
                    ScfCode: ""
                },
                config: {
                    service: ServiceInductors,
                    model: {
                        ItemCode : "ID",
                        // AvgPrice: "decimal"
                    },
                    headers: [
                        // { text: "ID", value: "Id" },
                        { text: "Número de artículo", value: "ItemCode" },
                        { text: "Descripción", value: "ItemName" },
                        { text: "Grupo de artículos", value: "ItmsGrpNam" },
                        { text: "Método de Valorización", value: "EvalSystemName" },
                        { text: "Costo del Articulo", value: "AvgPrice" },
                        { text: "Estado", value: "ItemStatus" },
                    ]  
                },
                itemSelected: {},
                openModal: false,
                item: {
                    EvalSystem: 2,
                    ItemCode: ""
                },
                listMaterial:[] ,
                headersListMaterial:[
                    { text: "Nº producto PT", value: "Father",width: 80,},
                    { text: "Descripción PT", value: "Name"},
                    { text: "Nº Inductor", value: "Code"},
                    { text: "Descripción IND", value: "ItemName"},
                    { text: "Cantidad", value: "Quantity"},
                    { text: "Almacén", value: "Warehouse"},
                    { text: "Centros de Costo", value: "OcrCode"},
                    { text: "Nombre Centro de Costo", value: "OcrName"},
                    { text: "Lineas de Negocio", value: "OcrCode2"},
                    { text: "Nombre Lineas de Negocio", value: "OcrName2"},
                    { text: "Tipo de Costo", value: "OcrCode3"},
                ],
                itemsSearch: [], //Listado
			    selectedSearch: [],
			    viewItemSearch: {},
			    search: "",
                
            }
        },
        methods:{
            save(){                
                console.log("Filas a modificar",this.listMaterial);   
                console.log("Cantidad",this.item.Quantity);            
                // item.save();

                this.ussUserCode = this.$fun.getUserSAPInfo().UssUserCode;
                
                if (this.ussUserCode == null) {
                    this.$fun.alert( "No tiene un Usuario SAP autenticado, Comuniquese con el Área de TECNOLOGÍA DE LA INFORMACIÓN..","warning",);
                    return;
                }
                
                console.log("Usuario de Sap",this.$fun.getUserSAPInfo().UsrID);

                this.$fun.alert("Seguro de modificar estas Listas de Materiales en SAP ? ", "question")
                    .then(r => {
                        if (r.value) {
                            // console.log("Prueba", this.itemsSelected);
                            this.processingSA = true;

                            ServiceInductors
                                .ListMaterialsServiceLayer(this.listMaterial,
                                    this.$fun.getUserSAPInfo().UsrID,
                                    //284,                
                                    this.$fun.getUserID())
                                .then(resp => {
                                    if (resp.status == 200) {
                                        this.processingSA = false;
                                        this.$fun.alert("Subido Correctamente", "success");
                                        this.close();
                                        this.clear();
                                        this.$refs.InductorsList.refresh();
                                    }
                                    
                                },
                                    (e) => {
                                        this.errorSap = true;
                                        this.messageProcessingSAP = e.response.data.Message;
                                        this.processingSA = true;
                                        this.$refs.InductorsList.refresh();
                                    }
                                    
                                );
                        }else{
                            clear();
                            this.$refs.InductorsList.refresh();
                        }
                })
                console.log("Filas a modificadas",this.listMaterial);

                // this.item.AvgPrice = 0;
                
            },
            clear(){
                this.item.Quantity = 0; 
            },
            rowSelected(row){
                console.log("Fila",row);
                this.itemSelected = row[0];
            },
            send(){
                console.log("Filas seleccionadas",this.itemSelected);
                this.openModal = true;
                this.item = this.itemSelected;
                this.getListOfMaterial();
            },
            getListOfMaterial(){
                ServiceInductors.getListMaterials(this.itemSelected,this.$fun.getUserID())
                    .then(r => {
						this.listMaterial = r.data;
						
                        console.log(this.listMaterial[0].ItemCode);
					});
            },
            addQuantity(){
                console.log("Filas selecciona para agregar cantidad", this.selectedSearch)
                this.selectedSearch.forEach((element) => {                    
                    element.Quantity = this.item.Quantity;                
                });
                this.item.Quantity =0;
                this.selectedSearch = [];
            },
            close() {
				this.openModal = false;				
			},
        }
    }

</script>